/**
 * ID generation utilities for LinCal entities
 */

/**
 * Generate a unique ID with prefix
 * @param {string} prefix - Prefix for the ID (e.g., 'evt', 'ms', 'proj')
 * @returns {string} Unique ID in format: prefix_timestamp_random
 */
export function generateId(prefix = 'id') {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Generate an ISO timestamp string for the current time
 * @returns {string} ISO timestamp
 */
export function generateTimestamp() {
  return new Date().toISOString();
}
